// extracted by mini-css-extract-plugin
export default {"container":"rp-z","heading":"sp-z","text":"tp-z","info":"up-z","link":"vp-z","fullMaxWidth":"wp-z"};